<template>
<transition @leave="leave">
  <a-circle
    color="#fc1f1f"
    position="0 0 .005"
    radius=".33"
    ref="el"
    segments="64"
    transparent="true"
    material="shader: flat"
    scale="0 0 0"
    @loaded="loaded"
  >
    <a-entity scale="1.2 1.2 1.2">
      <a-image
        ref="roxham"
        :src="cdn(require('./img/roxham.png'))"
        height=".5" width=".5"
        @materialtextureloaded="elLoaded"
        shader="flat" position="0 0 .01"
        opacity="0"
      />
      <a-plane
        material="shader: flat"
        height=".12" width=".45"
        @loaded="elLoaded"
        position="0 0 .011"
        scale="0 1 1"
        ref="bar"
      />
      <a-image
        :src="cdn(require('./img/infos-1-' + lang + '.png'))"
        height=".7" width=".7"
        @materialtextureloaded="elLoaded"
        shader="flat" position="0 0 .011"
        ref="info_1"
        opacity="0"
      />
      <a-image
        :src="cdn(require('./img/infos-2-' + lang + '.png'))"
        height=".8" width=".8"
        @materialtextureloaded="elLoaded"
        shader="flat" position="0 0 .012"
        ref="info_2"
        opacity="0"
      />
    </a-entity>
  </a-circle>
</transition>
</template>

<script>
import Settings from '@/config/Settings'

export default {
  name: 'Infos',
  data: () => ({
    elsLoaded: 0,
    checkPos: [
      {
        ref: 'el',
        desktop: { scale: 1 },
        mobile: { scale: .7, y: 0 },
        landscape: { scale: .6, y: -.035 }
      },
    ]
  }),
  watch: {
    elsLoaded(){
      if(this.elsLoaded === 4)
        this.enter()
    }
  },
  methods: {
    loaded() {
      this.$el.object3DMap.mesh.material.blending = THREE.MultiplyBlending
    },
    elLoaded() {
      this.elsLoaded++
    },
    enter() {
      this.setDyniquePos()
      const tl = new TimelineMax()
      .from(this.$el, 1, { aframe: { scale: 0 } })
      .to(this.$refs.roxham, 2, { aframe: { alpha: 1 }})
      .to({}, 2, {})
      .to(this.$refs.bar, 1, { aframe: { scaleX: 1 }, ease: Expo.easeOut })
      .set(this.$refs.roxham, { aframe: { scale: 0 }})
      .to({}, 1, {})
      .to(this.$refs.bar, 1, { aframe: { scaleX: 0 }, ease: Expo.easeOut})
      .set(this.$refs.bar, { aframe: { alpha: 0 } })
      .to(this.$refs.info_1, 1, { aframe: { alpha: 1 }})
      .to({}, 2, {})
      .to(this.$refs.info_1, 1, { aframe: { alpha: 0 }})
      .to(this.$refs.info_2, 1, { aframe: { alpha: 1 }})
      .to({}, 4, {})
      .to(this.$refs.info_2, 1, { aframe: { alpha: 0 }})
      .call(() => this.$router.push({ name: 'wait.' + this.lang }))

      if(Settings.fast)
        tl.timeScale(10)

      this.$tl = tl
    },
    leave(el, done) {
      if(this.$tl)
        this.$tl.kill()
      const els = [this.$refs.roxham, this.$refs.bar, this.$refs.info_1, this.$refs.info_2]
      TweenLite.to(els, 1, { aframe: { alpha: 0 }, onComplete: done })
      TweenLite.to(this.$el, 1, { delay: 0, aframe: { scale: 0 } })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/infos/Infos.vue